import React, {useCallback, useState} from "react";
import ActionButton from "../actions/ActionButton";
import FormModal from "../common/modal/FormModal";

const UpdateOrder = ({item,onOrderUpdate, formData}) => {

    const [modalOpen, setModalOpen] = useState(false);

    const openModalHandler = () => {
        setModalOpen(true);
    };

    const formModalSubmit = useCallback((item) => {
        setModalOpen(false);
        onOrderUpdate(item);
    }, [onOrderUpdate]);

    const cancelModal = useCallback(() => {
        setModalOpen(false);
    }, []);



    const selectedItem = {
        formTitle: "Update Order",
        row: item,
        formData: formData,
    }

    return (
        <>
            <ActionButton
                permissions={['BranchAdmin', 'BranchOwner', 'BranchManager']}
                className="btn bg-primary bg-opacity-25 fs-sm fw-medium rounded-2 py-1"
                action={openModalHandler}
            >
                Update Order
            </ActionButton>
            <FormModal item={selectedItem} isOpen={modalOpen} onCancel={cancelModal} onSubmit={formModalSubmit} />
        </>
    );
}

export default UpdateOrder;
